import { ROUTES } from '#/config/routes';

/**
 * 客訂明細 →「建立多階層工單」deep link（帶 lineId；可選 productId）。
 * @returns {string|null} 無 customerOrderId 或 line.id 時回傳 null
 */
export function buildManufacturingMaterialsUrlFromCustomerOrderLine(
  customerOrderId,
  line,
) {
  if (!customerOrderId || line?.id == null || line?.id === '') {
    return null;
  }

  const params = new URLSearchParams();
  params.set('lineId', String(line.id));

  const productId = line?.product?.id ?? line?.productId;
  if (productId) {
    params.set('productId', String(productId));
  }

  return `${ROUTES.customerOrderManufacturingMaterials(customerOrderId)}?${params.toString()}`;
}
